import { ArrowRight } from "lucide-react";
import { useState } from "react";
import { ProjectModal } from "./ProjectModal";

export function MidCTA() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="py-16 md:py-20 bg-white border-y border-slate-100">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
          Still wondering if we are the right fit?
        </h2>
        <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto">
          We offer a free 30-minute discovery session. No sales pitch, just honest advice on your current digital challenges.
        </p>
        <button
          onClick={() => setIsModalOpen(true)}
          className="w-full md:w-auto inline-flex justify-center items-center gap-2 px-8 py-4 bg-slate-900 text-white font-semibold rounded-lg hover:bg-[#FD5750] transition-colors shadow-lg cursor-pointer"
        >
          Book Your Discovery Session <ArrowRight size={20} />
        </button>
      </div>

      <ProjectModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
}
